import React from "react";
import {
  InfoFetchError,
  UserApplicationDataResponse,
  UserApplicationsResponse,
} from "@songtradr-sso/shared/common";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.components.userApplications;

// STYLES

// DATA

// TYPES
export type Props = {
  apps?: UserApplicationsResponse | InfoFetchError;
  showHeader?: boolean;
  /** If linkFormat is true, the app rows will act as links to their respective apps
   *
   * If linkFormat is false, the app rows will not serve as links,
   * and instead will display the user's roles in each respective app
   */
  linkFormat?: boolean;
  /** Optional callback to render an action element for each app row */
  renderAction?: (app: UserApplicationDataResponse) => React.ReactNode;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
